module.exports = __webpack_public_path__ + "img/plus-for-scripts.00e1a50b.svg";